<template>
    <div class="card">
        <div v-if="user">
        <h1>User details</h1>
        <p class="first-para grey-letters">Name: {{ user?.username?.split('@')[0] }}</p>
        <p class="grey-letters">Joined at: {{ user?.date_joined?.split('T')[0] }}</p>
        <p class="grey-letters">email: {{ user?.email }}</p>
        </div>
        <div class="button-container">
        <button @click="signOut" class="logout-btn">Logout</button>
        </div>
    </div>
</template>


<script lang="ts">

import { defineComponent, ref, onMounted, PropType } from 'vue';
import { storeToRefs } from "pinia";
import { useRouter } from 'vue-router';
import { supabase } from '../lib/supabase';
import { useAuthStore } from '../stores/auth';
import { useUserStore } from '@/stores/user';
import User from '../types/User';


export default defineComponent({
    name: 'UserPanel',
    props: {
    user: {
      type: Object as PropType<User>,
      required: false,
    },
  },

    setup() {
        const username = ref<string>('')
        const joinedAt = ref<string>('')
        const email = ref<string>('')
        const authStore = useAuthStore();
        const userStore = useUserStore();
        const { session } = storeToRefs(authStore)
        const router = useRouter();
        const result = ref<User>()

        
        const signOut = async () => {
            await supabase.auth.signOut();
            authStore.setSession(null);
            userStore.clearUser();
            router.push('/')
        }

        return {
            session,
            username,
            email,
            result,
            signOut,
            joinedAt,
        }
    }
})

</script>

<style scoped>

.user-info {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    justify-content: center;
}

.button-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    justify-content: center;
}


.logout-btn {
  background: none;
  border: 3px solid #f9a1a1;
  font-size: 0.8rem;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  padding: 0.6rem 1.2rem;
  border-radius: 10px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background-color: #f9a1a1;
}

.logout-btn:hover {
  border-color: #f9a1a1;
  background-color: #f9a1a1;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.card {
  background-color: white;
  width: 88%;
  border-bottom: 2px solid #ccc;
  max-width: 400px;
  margin: 20px 0 30px 0;
  padding: 20px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card h1 {
      text-align: center;
      font-size: 2.2rem;
      line-height: 1.1;
      font-weight: 800;
      margin-bottom: -15px;
  }

.first-para {
  margin-top: 30px;
}

h2 {
    text-align: center;
}

hr.user-hr {
    margin-top: 1rem;
    width: 100%;
    border: 1px solid gray;
}
</style>


